function getValidDuration(durations: Durations, policy: number): Duration {
  const duration: Duration = durations[policy]

  if (duration) {
    return duration
  } else {
    const keys = Object.keys(durations)

    return durations[keys[keys.length - 1]]
  }
}

export default getValidDuration
